<script setup lang="ts">
import { computed } from 'vue';

import { useToast } from '@/hooks';

const { toastContent, resetToast, toastType, showToast } = useToast();

const toastIcon = computed(() => {
  switch (toastType.value) {
    case 'success':
      return 'check';
    case 'error':
      return 'mark';
    case 'info':
      return 'info';
    case 'warning':
      return 'exclamationFilled';
    default:
      return '';
  }
});
</script>

<template>
  <Transition name="slide-right" appear>
    <div v-if="showToast" class="toast-container" :class="toastType">
      <div class="flex items-center gap-3">
        <div v-if="!!toastIcon" class="toast-icon" :class="toastType">
          <Icon :icon-name="toastIcon" class="w-4 h-4" />
        </div>

        <div class="toast-content">
          {{ toastContent }}
        </div>
      </div>

      <button type="button" @click="resetToast">
        <Icon icon-name="mark" class="w-4 h-4" />
      </button>
    </div>
  </Transition>
</template>

<style scoped>
.toast-container {
  @apply fixed top-5 right-5 z-[100] flex items-center justify-between gap-4 w-full max-w-xs p-4 text-gray-500 bg-white shadow-lg rounded-lg border-b;

  &.success {
    @apply border-green-700;
  }

  &.error {
    @apply border-red-500;
  }

  &.warning {
    @apply border-yellow-500;
  }

  &.info {
    @apply border-blue-500;
  }
}

.toast-icon {
  @apply inline-flex justify-center items-center shrink-0 w-8 h-8 rounded-lg;

  &.success {
    @apply text-green-700 bg-green-100;
  }

  &.error {
    @apply text-red-500 bg-red-100;
  }

  &.warning {
    @apply text-yellow-500 bg-yellow-100;
  }

  &.info {
    @apply text-blue-500 bg-blue-200;
  }
}

.toast-content {
  @apply ml-3 text-sm font-normal;
}
</style>
